import React from 'react';
import { Check, Close } from '@mui/icons-material';

const OdebranoItem = (props) => {

  return (
    <>
    {props.odebrano ? 
    <Check className={"odebrano_ok"} fontSize="large"/>
    : 
    <Close className={"odebrano_nok"} fontSize="large" />
    }
  </>
  );

}

export default OdebranoItem